import {
  IContentAreaProps,
  IDataContext,
  IMenuButton, ISelectedNode,
  IViewController
} from "../../types";
import { ReactElement } from "react";
import BuildIcon from "@mui/icons-material/Build";
import VariablesPage from "./components/acquisition/variablesPage";
import FactoryIcon from "@mui/icons-material/Factory";
import CatalogPage from "./components/catalog/catalogPage";
import RecipeEditor from "../meltShop/recipeEditor";
import ScienceIcon from '@mui/icons-material/Science';
import {cloneObject} from "../../system/utils";

class Module implements IViewController {

  private variablesButton: IMenuButton = {
    title: "Variables",
    icon: <BuildIcon/>,
    color: "blueGray",
    dataContext: {
      title: "Variables",
      module: "config",
      subModule: "config/variables"
    }
  };

  private specificationButton: IMenuButton = {
    title: "Specification",
    icon: <FactoryIcon/>,
    color: "orange",
    dataContext: {
      title: "Specification",
      module: "config",
      subModule: "config/spec"
    }
  };

  private alloysButton: IMenuButton = {
    title: "Alloys",
    icon: <ScienceIcon/>,
    color: "orange",
    dataContext: {
      title: "Alloys",
      module: "config",
      subModule: "config/alloys"
    }
  };


  private groupGroupButton: IMenuButton = {
    title: "Config",
    icon: <BuildIcon/>,
    color: "blueGray",
    disabled: false,
    children: [this.variablesButton],
    dataContext: {
      title: "Config",
      module: "config",
      subModule: "configGroup"
    }
  };

  private buttons = [this.groupGroupButton, this.variablesButton, this.specificationButton, this.alloysButton];

  public getModuleName(): string {
    return "config";
  }

  public getView(dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    if (dataContext.subModule === "config/variables") {
      return <VariablesPage parentSize={props.parentSize}/>;
    }

    if (dataContext.subModule === "config/spec") {
      return <CatalogPage parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "config/alloys") {
      return <RecipeEditor parentSize={props.parentSize} />;
    }

    return <div />;
  }

  getButtons(): IMenuButton[] {
    return [];
  }

  getButton(subModule: string, selectedNode?: ISelectedNode | null): IMenuButton | undefined {
    const button = this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);

    if (!button || !selectedNode) {

      return button;
    }

    if (button.dataContext.subModule === "configGroup"){
      if (selectedNode.code === "EAF") {
        button.children = [ this.variablesButton, this.alloysButton ];
      } else {
        button.children = [ this.variablesButton ];
      }

    }

    return button;
  }

  getIndicator(): ReactElement | undefined {
    return undefined;
  }
}

const instance = new Module();

export default instance;
